/**
 * The console's six areas. Each is navigated independently and loads only the data it
 * needs, so opening Settings doesn't wait on tournaments.
 */
export type AdminView = 'overview' | 'rooms' | 'tags' | 'templates' | 'points' | 'settings';

export const ADMIN_VIEWS: readonly { id: AdminView; label: string; description: string }[] = [
  {
    id: 'overview',
    label: 'Overview',
    description: 'Activity across every room on the platform.',
  },
  {
    id: 'rooms',
    label: 'Rooms',
    description: 'Register rooms, switch features on, and decide who may manage each one.',
  },
  {
    id: 'tags',
    label: 'Tags',
    description: "Platform tags every room can apply to a tournament but can't remove.",
  },
  {
    id: 'templates',
    label: 'Templates',
    description: 'Templates defined once here; each room supplies its own content for them.',
  },
  {
    // Sits beside Tags and Templates rather than under Rooms: like those, it is a platform
    // vocabulary every room can draw on. A room builds its own systems in its own console; what
    // is created here is owned by nobody's room and offered to all of them.
    id: 'points',
    label: 'Points systems',
    description:
      'How finishes turn into points. Systems defined here are offered to every room, which may use one as it stands or clone it.',
  },
  {
    id: 'settings',
    label: 'Settings',
    description: 'Platform-wide settings that every room inherits.',
  },
] as const;

export const ADMIN_VIEW = Object.fromEntries(ADMIN_VIEWS.map((v) => [v.id, v])) as Record<
  AdminView,
  (typeof ADMIN_VIEWS)[number]
>;
